import React, { useRef, useState, useEffect } from "react";
import HtmlDiff from "htmldiff-js";
import DOMPurify from "dompurify";
import { motion } from "framer-motion";
import "../../assets/css/common/htmlDiff.css";


const HtmlDiffViewer = ({ oldHtml, newHtml, setLegends, mergeLegends = false }) => {
  const [view, setView] = useState("unified");

  const leftRef = useRef(null);
  const rightRef = useRef(null);

  // diff HTML
  const diffHtml = HtmlDiff.execute(oldHtml, newHtml);

  // sanitize with ins/del support
  const sanitizedDiff = DOMPurify.sanitize(diffHtml, {
    ADD_TAGS: ["ins", "del"],
    ADD_ATTR: ["class", "style"],
  });

  // split views (hide ins in left, hide del in right)
  const sanitizedOld = DOMPurify.sanitize(oldHtml, {
    ADD_TAGS: ["ins", "del"],
    ADD_ATTR: ["class", "style"],
  }).replace(/<ins[\s\S]*?<\/ins>/g, "");

  const sanitizedNew = DOMPurify.sanitize(newHtml, {
    ADD_TAGS: ["ins", "del"],
    ADD_ATTR: ["class", "style"],
  }).replace(/<del[\s\S]*?<\/del>/g, "");

  // sync scroll between split panes
  const syncScroll = (source, target) => {
    if (!source.current || !target.current) return;
    target.current.scrollTop = source.current.scrollTop;
  };

  useEffect(() => {
    const added = (sanitizedDiff.match(/<ins[\s\S]*?<\/ins>/g) || []).length;
    const removed = (sanitizedDiff.match(/<del[\s\S]*?<\/del>/g) || []).length;
    const modified = Math.min(added, removed); // Lines modified are the minimum of added/removed
    setLegends(prev => mergeLegends
    ? {
        added: prev.added + added,
        removed: prev.removed + removed,
        modified: prev.modified + modified,
      }
    : { added, removed, modified }
  );
  }, [sanitizedDiff, mergeLegends]);

  return (
    <div className="diff-container">
      {/* Toggle buttons */}
      {/* <div className="diff-toolbar">
        <button
          onClick={() => setView("split")}
          className={view === "split" ? "active" : ""}
        >
          Split View
        </button>
        <button
          onClick={() => setView("unified")}
          className={view === "unified" ? "active" : ""}
        >
          Unified View
        </button>
      </div> */}

      {/* Split view */}
      {view === "split" ? (
        <div className="split-view">
          <div
            ref={leftRef}
            onScroll={() => syncScroll(leftRef, rightRef)}
            className="pane"
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              dangerouslySetInnerHTML={{ __html: sanitizedOld }}
            />
          </div>

          <div
            ref={rightRef}
            onScroll={() => syncScroll(rightRef, leftRef)}
            className="pane"
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              dangerouslySetInnerHTML={{ __html: sanitizedNew }}
            />
          </div>
        </div>
      ) : (
        // Unified view
        <div className="unified-view">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            dangerouslySetInnerHTML={{ __html: sanitizedDiff }}
          />
        </div>
      )}
    </div>
  );
};

export default HtmlDiffViewer;